import React, { useState, useRef, useEffect } from "react";
import Agreement from "../../../template/flexIndustrialLeaseAgreementSample";
import ButtonTag from "../../../reusebale/button";
import ParagraphTag from "../../../reusebale/Paragraph";
import ImageTag from "../../../reusebale/imageTag";
import { ArrowBigDown } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import { ShowError, ShowSuccess } from "../../../../utils/ToasFunction";
import BaseUrl from "../../../../constants/BaseUrl";
import MyLoader from "../../../reusebale/myLoader";
import PropertySuccessPopup from "../../../popup/propertySuccess";
import * as LeaseAction from "../../../../store/actions/lease/LeaseAction";
import { GetNotificationMessageByKey } from "../../../../db/NotificationMsgList";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { validateAdditionalTerms, initializeAdditionalTerms } from "../../../template/flexIndustrialLeaseAdditionalTermsCheckboxes";

const Overview = ({ formData, tenentInfo, onClose, onFormDataChange, getCurrentFormData }) => {
  const { loginSuccess } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [showSuccess, setShowSuccessPopup] = useState(false);
  const [localFormData, setLocalFormData] = useState(formData);
  const { leaseData, leaseUpdate, isRenewal } = useSelector(
    (state) => state.lease
  );
  
  // Sync localFormData with formData prop when it changes
  useEffect(() => {
    // If formData doesn't have additionalTerms, initialize them
    if (formData && (!formData.additionalTerms || formData.additionalTerms.length === 0)) {
      const initialTerms = initializeAdditionalTerms();
      const updatedFormData = {
        ...formData,
        additionalTerms: initialTerms
      };
      setLocalFormData(updatedFormData);
      if (onFormDataChange) {
        onFormDataChange(updatedFormData);
      }
    } else {
      setLocalFormData(formData);
    }
  }, [formData]);
  
  const closePopup = () => {
    setShowSuccessPopup(false);
    onClose();
    dispatch(LeaseAction.ChangePropertyCreateSteps(1));
  };

  function calculateTotalAmount(list, unitRent = 0) {
    if (!Array.isArray(list)) {
      throw new Error("Input must be an array of objects");
    }

    const total = list.reduce((sum, item) => {
      if (typeof item.amount !== "string") {
        throw new Error(
          `Invalid amount format for item: ${JSON.stringify(item)}`
        );
      }
      const amount = parseFloat(item.amount);
      if (isNaN(amount)) {
        throw new Error(
          `Invalid amount value for item: ${JSON.stringify(item)}`
        );
      }
      return sum + amount;
    }, 0);

    // Add unit rent to the total
    return total + (unitRent || 0);
  }
  const [loading, setLoading] = useState(false);

  const CreateNotification = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      landlordId: loginSuccess.user._id,
      title: GetNotificationMessageByKey("new_lease").title,
      description: `${GetNotificationMessageByKey("new_lease").description} ${
        localFormData?.propertyInfo?.propertyName
      }`,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/notification/createNotification`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          // ShowSuccess("Notification Created Successfully")
        }
      })
      .catch((error) => console.error(error));
  };

  const CreateNotificationUpdate = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      landlordId: loginSuccess.user._id,
      title: GetNotificationMessageByKey("new_update").title,
      description: `${GetNotificationMessageByKey("new_update").description} ${
        localFormData?.propertyInfo?.propertyName
      }`,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/notification/createNotification`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          // ShowSuccess("Notification Created Successfully")
        }
      })
      .catch((error) => console.error(error));
  };

  const CreateLeaseHadnler = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const raw = JSON.stringify({
      propertyInfo: localFormData?.propertyInfo,
      unitInfo: localFormData.unitInfo,
      leaseTerm: localFormData.leaseTerm,
      startDate: localFormData.startDate,
      endDate: localFormData.endDate,
      annualIncrementPercentage: localFormData.annualIncrementPercentage || 0,
      tenantInfo: tenentInfo,
      rentStartDate: localFormData.rentStartDate,
      rentFrequency: localFormData.rentFrequency,
      chargeLate: localFormData.chargeLate,
      latePercentage: localFormData.latePercentage,
      graceDays: localFormData.graceDays,
      lateFixedAmount: localFormData.lateFixedAmount ?? 500,
      lateInterestRate: localFormData.lateInterestRate ?? 5,
      additionalCharges: localFormData.additionalCharges,
      securityDeposit: localFormData.securityDeposit,
      securityDepositAmount: localFormData.securityDepositAmount,
      rentSchedule: Array.isArray(localFormData.rentSchedule) ? localFormData.rentSchedule : [],
      isFirstMonthFree: !!localFormData.isFirstMonthFree,
      additionalTerms: localFormData.additionalTerms || [],
      isEsignature: localFormData.isEsignature,
      eSignature: localFormData.eSignature,
      deliveryConditions: localFormData.deliveryConditions || {
        broomClean: false,
        hvacOperational: false,
        electricalOperational: false,
        rollUpDoorsOperational: false,
        restroomFixturesOperational: false,
      },
      brokerInfo: localFormData.brokerInfo,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/lease/createNewLease`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "success") {
          setLoading(false);
          ShowSuccess("Lease created successfully");
          setShowSuccessPopup(true);
          CreateNotification();
        } else {
          setLoading(false);
          ShowError(result.message);
        }
      })
      .catch((error) => console.error(error));
  };

  const onUpdateLeaseHanadler = () => {
    setLoading(true);

    // Get the absolute latest form data from parent to ensure we have updated unitInfo
    const latestFormData = getCurrentFormData ? getCurrentFormData() : localFormData;

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      leaseId: leaseData._id,
      landlordId: loginSuccess.user._id,
      propertyInfo: latestFormData.propertyInfo,
      unitInfo: latestFormData.unitInfo,
      leaseTerm: latestFormData.leaseTerm,
      startDate: latestFormData.startDate,
      endDate: latestFormData.endDate,
      annualIncrementPercentage: latestFormData.annualIncrementPercentage || 0,
      tenantInfo: tenentInfo,
      rentStartDate: latestFormData.rentStartDate,
      rentFrequency: latestFormData.rentFrequency,
      chargeLate: latestFormData.chargeLate,
      latePercentage: latestFormData.latePercentage,
      graceDays: latestFormData.graceDays,
      lateFixedAmount: latestFormData.lateFixedAmount ?? 500,
      lateInterestRate: latestFormData.lateInterestRate ?? 5,
      additionalCharges: latestFormData.additionalCharges,
      securityDeposit: latestFormData.securityDeposit,
      securityDepositAmount: latestFormData.securityDepositAmount,
      rentSchedule: Array.isArray(latestFormData.rentSchedule) ? latestFormData.rentSchedule : [],
      isFirstMonthFree: !!latestFormData.isFirstMonthFree,
      additionalTerms: latestFormData.additionalTerms || [],
      isEsignature: latestFormData.isEsignature,
      eSignature: latestFormData.eSignature,
      deliveryConditions: latestFormData.deliveryConditions || {
        broomClean: false,
        hvacOperational: false,
        electricalOperational: false,
        rollUpDoorsOperational: false,
        restroomFixturesOperational: false,
      },
      brokerInfo: latestFormData.brokerInfo,
      conversation: leaseData.conversation,
      status: leaseData.inActive,
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/lease/updateLease`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "success") {
          setLoading(false);
          CreateNotificationUpdate();
          // Clear the lease data from Redux so it fetches fresh data next time
          dispatch(LeaseAction.ClearAllLeaseDetailsAction());
          setShowSuccessPopup(true);
        } else {
          setLoading(false);
          ShowError("Oops! something went wrong");
        }
      })
      .catch((error) => console.error(error));
  };

  const onRenewLeaseHandler = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      startDate: localFormData.startDate,
      endDate: localFormData.endDate,
      annualIncrementPercentage: localFormData.annualIncrementPercentage || 0,
      rentStartDate: localFormData.rentStartDate,
      rentFrequency: localFormData.rentFrequency,
      chargeLate: localFormData.chargeLate,
      latePercentage: localFormData.latePercentage,
      graceDays: localFormData.graceDays,
      lateFixedAmount: localFormData.lateFixedAmount ?? 500,
      lateInterestRate: localFormData.lateInterestRate ?? 5,
      additionalCharges: localFormData.additionalCharges,
      securityDeposit: localFormData.securityDeposit,
      securityDepositAmount: localFormData.securityDepositAmount,
      additionalTerms: localFormData.additionalTerms || [],
      deliveryConditions: localFormData.deliveryConditions || {
        broomClean: false,
        hvacOperational: false,
        electricalOperational: false,
        rollUpDoorsOperational: false,
        restroomFixturesOperational: false,
      },
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/lease/renew/${leaseData._id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "success") {
          setLoading(false);
          ShowSuccess("Lease renewed successfully");
          setShowSuccessPopup(true);
          // Clear renewal mode
          dispatch(LeaseAction.ClearLeaseRenewalModeAction());
        } else {
          setLoading(false);
          ShowError(result?.message);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
        ShowError("Oops! something went wrong");
      });
  };

  const agreementRef = useRef();

  const generatePDF = () => {
    // const agreementRef = useRef(null)

    // Apply temporary styling fixes
    const applyTemporaryStyles = () => {
      const content = agreementRef.current;
      if (!content) return {};

      // Store original styles to restore later
      const originalStyles = new Map();

      // Save and set the root document container to full width for PDF
      originalStyles.set('root-container', {
        element: content,
        width: content.style.width,
        padding: content.style.padding,
      });
      
      // Set to full A4 width for PDF generation
      content.style.width = '190mm';
      content.style.padding = '15mm';

      // Find heading elements that might have border issues
      const headings = content.querySelectorAll("h1, h2, h3, .title, .heading");

      headings.forEach((heading, index) => {
        // Save original styles
        originalStyles.set(`heading-${index}`, {
          element: heading,
          padding: heading.style.padding,
          margin: heading.style.margin,
          lineHeight: heading.style.lineHeight,
          position: heading.style.position,
          zIndex: heading.style.zIndex,
        });

        // Apply temporary fixes
        heading.style.padding = "15px 0";
        heading.style.margin = "15px 0";
        heading.style.lineHeight = "1.5";
        heading.style.position = "relative";
        heading.style.zIndex = "2";
      });

      // Fix input rendering for PDF - make them render with clear text
      const allInputs = content.querySelectorAll('input[type="text"]');
      
      allInputs.forEach((input, index) => {
        originalStyles.set(`input-${index}`, {
          element: input,
          backgroundColor: input.style.backgroundColor,
          color: input.style.color,
          WebkitAppearance: input.style.WebkitAppearance,
        });
        
        // Force inputs to render clearly in PDF
        input.style.backgroundColor = '#FFFFFF';
        input.style.color = '#000000';
        input.style.WebkitAppearance = 'none';
        input.style.fontWeight = '600';
      });

      return originalStyles;
    };

    // Restore original styles after PDF generation
    const restoreStyles = (originalStyles) => {
      originalStyles.forEach((styles, key) => {
        const { element, padding, margin, lineHeight, position, zIndex, width, display, backgroundColor, color, WebkitAppearance } = styles;
        
        // Restore all saved properties
        if (width !== undefined) element.style.width = width;
        if (padding !== undefined) element.style.padding = padding;
        if (margin !== undefined) element.style.margin = margin;
        if (lineHeight !== undefined) element.style.lineHeight = lineHeight;
        if (position !== undefined) element.style.position = position;
        if (zIndex !== undefined) element.style.zIndex = zIndex;
        if (display !== undefined) element.style.display = display;
        if (backgroundColor !== undefined) element.style.backgroundColor = backgroundColor;
        if (color !== undefined) element.style.color = color;
        if (WebkitAppearance !== undefined) element.style.WebkitAppearance = WebkitAppearance;
      });
    };

    // Apply temporary styles and store original values
    const originalStyles = applyTemporaryStyles();

    // Generate PDF with improved settings
    html2canvas(agreementRef.current, {
      allowTaint: true,
      useCORS: true,
      scale: 2, // Higher scale for better quality
      logging: false,
      height: agreementRef.current.scrollHeight,
      width: agreementRef.current.scrollWidth,
      windowHeight: agreementRef.current.scrollHeight + 100,
      windowWidth: agreementRef.current.scrollWidth,
      imageTimeout: 15000,
      letterRendering: true,
      backgroundColor: "#FFFFFF",
      removeContainer: false,
      foreignObjectRendering: false,
    })
      .then((canvas) => {
        // Restore original styles immediately after canvas is generated
        restoreStyles(originalStyles);

        const doc = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
          compress: true,
        });

        const pageWidth = 210; // A4 page width in mm
        const pageHeight = 297; // A4 page height in mm
        const margin = 10; // Standard margins
        const contentWidth = pageWidth - 2 * margin; // 190mm (matches component width)
        const contentHeight = pageHeight - 2 * margin; // Available height per page

        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        // Detect actual content height by finding the bottom-most non-white pixel
        let actualContentHeight = canvasHeight;
        const ctx = canvas.getContext('2d');
        const imageData = ctx.getImageData(0, 0, canvasWidth, canvasHeight);
        const data = imageData.data;
        
        // Scan from bottom to top to find where content ends
        for (let y = canvasHeight - 1; y >= 0; y--) {
          let hasContent = false;
          for (let x = 0; x < canvasWidth; x++) {
            const idx = (y * canvasWidth + x) * 4;
            // Check if pixel is not white (allowing for slight variations)
            if (data[idx] < 250 || data[idx + 1] < 250 || data[idx + 2] < 250) {
              hasContent = true;
              break;
            }
          }
          if (hasContent) {
            actualContentHeight = y + 1; // Add 1 to include this row
            break;
          }
        }

        // Calculate image dimensions maintaining aspect ratio
        // Use full content width (190mm) to fill the PDF page
        const imgWidth = contentWidth;
        // Use actual content height instead of full canvas height
        const imgHeight = (actualContentHeight * contentWidth) / canvasWidth;

        // Calculate how many pages we need
        const totalPages = Math.ceil(imgHeight / contentHeight);

        // Add content across multiple pages
        let yPosition = 0;

        for (let i = 0; i < totalPages; i++) {
          if (i > 0) {
            doc.addPage(); // Add a new page for subsequent pages
          }

          // Calculate the height for this page - use actual remaining content
          const remainingHeight = imgHeight - yPosition;
          const pageImgHeight = Math.min(remainingHeight, contentHeight);
          
          // Only proceed if there's actual content to add
          if (pageImgHeight <= 0) break;
          
          // Calculate the source Y position in pixels
          const sourceY = (yPosition / imgHeight) * canvasHeight;
          const sourceHeight = (pageImgHeight / imgHeight) * canvasHeight;

          // Create a temporary canvas for this page's portion
          const pageCanvas = document.createElement('canvas');
          pageCanvas.width = canvasWidth;
          pageCanvas.height = sourceHeight;
          const pageCtx = pageCanvas.getContext('2d');
          pageCtx.drawImage(
            canvas,
            0, sourceY, canvasWidth, sourceHeight, // Source rectangle
            0, 0, canvasWidth, sourceHeight // Destination rectangle
          );

          // Add the page image to PDF - only use the actual content height
          doc.addImage(
            pageCanvas.toDataURL("image/jpeg", 1.0),
            "JPEG",
            margin,
            margin,
            imgWidth,
            pageImgHeight
          );

          yPosition += pageImgHeight;
          
          // If we've added all content, break early
          if (yPosition >= imgHeight) break;
        }

        // Save the PDF
        doc.save("lease-agreement.pdf");
      })
      .catch((error) => {
        console.error("PDF generation error:", error);
        // Restore styles even if there's an error
        restoreStyles(originalStyles);
        alert("There was an error generating the PDF. Please try again.");
      });
  };

  return (
    <div className="h-full pt-5">
      <div className="h-[90%] w-[95%] mx-auto flex justify-between pb-5">
        <div className="w-[56%]  border border-[#E8E8E8] rounded-md">
          <div className="h-[80%] overflow-y-scroll panelScroll bg-white overflow-x-auto">
            <Agreement
              ref={agreementRef}
              tenentInfo={tenentInfo}
              data={localFormData}
              onDeliveryConditionChange={(conditions) => {
                // Update local formData with new delivery conditions
                const updatedFormData = {
                  ...localFormData,
                  deliveryConditions: conditions,
                };
                setLocalFormData(updatedFormData);
                // Notify parent component if callback is provided
                if (onFormDataChange) {
                  onFormDataChange(updatedFormData);
                }
              }}
              onBrokerInfoChange={(brokerInfo) => {
                // Update local formData with new broker information
                const updatedFormData = {
                  ...localFormData,
                  brokerInfo: brokerInfo,
                };
                setLocalFormData(updatedFormData);
                // Notify parent component if callback is provided
                if (onFormDataChange) {
                  onFormDataChange(updatedFormData);
                }
              }}
              onAdditionalTermsChange={(additionalTerms) => {
                // Update local formData with new additional terms
                const updatedFormData = {
                  ...localFormData,
                  additionalTerms: additionalTerms,
                };
                setLocalFormData(updatedFormData);
                // Notify parent component if callback is provided
                if (onFormDataChange) {
                  onFormDataChange(updatedFormData);
                }
              }}
            />
          </div>

          <div className="h-[20%]">
            <div className="bg-[#FAF2EC] flex px-5 h-full items-center rounded-lg">
              <div className="w-[50%] flex items-center">
                <ImageTag
                  path="/assets/daashboard/pdf.png"
                  classes="w-[50px] h-[45px]"
                  altText="logo"
                />
                <div className="pl-2">
                  <ParagraphTag
                    content={`${localFormData?.propertyInfo?.propertyName}.pdf`}
                    classes="text-darkColor font-popinsSemiBold text-xs"
                  />
                  <ParagraphTag
                    content=""
                    classes="text-darkColor font-popinsMedium text-[10px] line-clamp-2 pt-[2px]"
                  />
                  <div className="flex pt-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="13"
                      viewBox="0 0 12 13"
                      fill="none"
                    >
                      <path
                        d="M3.20915 1.01507C3.20915 0.60703 3.54519 0.246997 3.97723 0.246997C4.38526 0.246997 4.7453 0.60703 4.7453 1.01507V1.78314H7.81758V1.01507C7.81758 0.60703 8.15362 0.246997 8.58566 0.246997C8.99369 0.246997 9.35373 0.60703 9.35373 1.01507V1.78314H10.5058C11.1299 1.78314 11.6579 2.31119 11.6579 2.93525V4.08736H0.90494V2.93525C0.90494 2.31119 1.40899 1.78314 2.05705 1.78314H3.20915V1.01507ZM11.6579 4.85543V11.384C11.6579 12.0321 11.1299 12.5361 10.5058 12.5361H2.05705C1.40899 12.5361 0.90494 12.0321 0.90494 11.384V4.85543H11.6579Z"
                        fill="#FF814E"
                      />
                    </svg>
                    <ParagraphTag
                      content={`${moment(new Date()).format("MM/DD/YYYY")}`}
                      classes="text-darkColor/40 font-popinsRegular text-xs pl-1"
                    />
                  </div>
                </div>
              </div>
              {/* Download button hidden during lease creation - only visible when viewing existing lease */}
              {false && (
                <div className="w-[50%] flex justify-end items-center">
                  <button
                    onClick={generatePDF}
                    className="border-2 border-themeColor flex justify-center items-center px-4 h-9 rounded-lg"
                  >
                    <ArrowBigDown color="#0381CA" size={20} />
                    <span className="text-themeColor font-popinsRegular text-xs pl-1">
                      Download Document
                    </span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="w-[42%] border border-[#E8E8E8] rounded-lg">
          <div className="h-[85%] w-[90%] mx-auto pt-4">
            <ParagraphTag
              content="Rent Breakdown"
              classes="text-darkColor font-popinsSemiBold text-base text-center pt-1"
            />
            <div className="h-[310px] overflow-y-scroll panelScroll">
              {/* Base Rent */}
              <div className="flex pt-5 justify-between">
                <div className="w-[50%]">
                  <ParagraphTag
                    content="Base Rent"
                    classes="text-darkColor font-popinsSemiBold text-xs"
                  />
                  <ParagraphTag
                    content={`Unit rent (${localFormData?.unitInfo?.rentType || "Monthly"})`}
                    classes="text-darkColor/40 font-popinsRegular text-xs line-clamp-1"
                  />
                </div>
                <div className="w-[50%] flex justify-end items-center">
                  <ParagraphTag
                    content={`$ ${Number(localFormData?.unitInfo?.rent || 0).toFixed(2).toString()}`}
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                </div>
              </div>
              {/* Additional Charges */}
              {localFormData?.additionalCharges?.map((i) => {
                return (
                  <div className="flex pt-5 justify-between">
                    <div className="w-[50%]">
                      <ParagraphTag
                        content={i?.title}
                        classes="text-darkColor font-popinsSemiBold text-xs"
                      />
                      <ParagraphTag
                        content={i?.description}
                        classes="text-darkColor/40 font-popinsRegular text-xs line-clamp-1"
                      />
                    </div>
                    <div className="w-[50%] flex justify-end items-center">
                      <ParagraphTag
                        content={`$ ${Number(i.amount).toFixed(2).toString()}`}
                        classes="text-darkColor font-popinsSemiBold text-sm"
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="h-[15%] border-t border-darkColor/10 w-[90%] mx-auto">
            {/* <div className="h-[1px] bg-darkColor/10 w-full mt-20"></div> */}
            <div className="flex py-5 justify-between">
              <div className="w-[50%]">
                <ParagraphTag
                  content="Total Amount"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
              </div>
              <div className="w-[50%] flex justify-end items-center">
                <ParagraphTag
                  content={`$ ${Number(
                    calculateTotalAmount(localFormData?.additionalCharges, localFormData?.unitInfo?.rent || 0)
                  ).toFixed(2)}`}
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="h-[10%] flex justify-center items-center">
        <div className="w-[50%] flex gap-4">
          {loading ? (
            <div className="flex justify-center">
              <MyLoader />
            </div>
          ) : (
            <>
              <ButtonTag
                onSubmit={(e) => {
                  e.preventDefault();
                  dispatch(LeaseAction.ChangePropertyCreateSteps(6));
                }}
                name="Back"
                classes="text-base text-center bg-gray-500 text-white"
              />
              <ButtonTag
                onSubmit={(e) => {
                  // isEsignature: formData.isEsignature,
                  // eSignature: formData.eSignature,
                  e.preventDefault();

                  if (!localFormData?.propertyInfo) {
                    ShowError("Property information is required");
                  } else if (!localFormData.unitInfo) {
                    ShowError("Unit information is required");
                  } else if (!localFormData.leaseTerm) {
                    ShowError("Lease term is required");
                  } else if (!localFormData.startDate) {
                    ShowError("Contract start date is required");
                  } else if (!localFormData.endDate) {
                    ShowError("Contract end date is required");
                  } else if (
                    localFormData.annualIncrementPercentage === "" ||
                    localFormData.annualIncrementPercentage === null ||
                    localFormData.annualIncrementPercentage === undefined
                  ) {
                    ShowError("Annual increment percentage is required");
                  } else if (tenentInfo.firstName === "") {
                    ShowError("Tenant first name is required");
                  } else if (tenentInfo.lastName === "") {
                    ShowError("Tenant last name is required");
                  } else if (tenentInfo.email === "") {
                    ShowError("Tenant email is required");
                  } else if (tenentInfo.cellNo === "") {
                    ShowError("Tenant cell number is required");
                  } else if (!localFormData.rentStartDate) {
                    ShowError("Rent start date is required");
                  } else if (!localFormData.rentFrequency) {
                    ShowError("Rent frequency is required");
                  } else if (
                    localFormData.chargeLate &&
                    (!localFormData.latePercentage || !localFormData.graceDays)
                  ) {
                    ShowError("Late cahrges information is missing");
                  } else if (!localFormData?.additionalCharges?.length === 0) {
                    ShowError("Rent breakdown is required");
                  } else if (
                    localFormData.securityDeposit &&
                    !localFormData.securityDepositAmount
                  ) {
                    ShowError("Deposit amount is required when security deposit is selected");
                  } else if (localFormData.isEsignature && !localFormData.eSignature) {
                    ShowError("E-Signature is missing");
                  } else {
                    // Validate additional terms
                    const validationResult = validateAdditionalTerms(localFormData.additionalTerms);
                    if (!validationResult.isValid) {
                      ShowError(validationResult.message);
                    } else {
                      // Use localFormData for submission to ensure latest delivery conditions are included
                      const finalFormData = localFormData;
                      if (isRenewal) {
                        onRenewLeaseHandler();
                      } else if (leaseUpdate) {
                        onUpdateLeaseHanadler();
                      } else {
                        CreateLeaseHadnler();
                      }
                    }
                  }
                }}
                name={
                  isRenewal ? "Renew Lease" : leaseUpdate ? "Update" : "Submit"
                }
                disabled={loading}
                classes="text-base text-center bg-themeColor text-white"
              />
            </>
          )}
        </div>
      </div>
      {showSuccess && (
        <PropertySuccessPopup
          succMessage={`${
            isRenewal
              ? "Lease renewed"
              : leaseUpdate
              ? "Lease updated"
              : "New lease created"
          } successfully.`}
          onClose={closePopup}
        />
      )}
    </div>
  );
};

export default Overview;
